export default "__VITE_ASSET__CCG1L_UK__"